
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'reference',
  source: 'endpoint',
  description: 'API reference for managing Items. Items, created with Link, enable access to Plaid products.',
  secondLevelToc: true,
  alwaysExpand: true,
  parentTocLevel: 3,
  childTocLevel: 4
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Schema = makeShortcode("Schema");
const MDXCodeBlock = makeShortcode("MDXCodeBlock");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Items' subtitle='API reference for managing Items' compact mdxType="Header" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Endpoints`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/item/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve an Item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/item/remove`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Remove an Item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/item/webhook/update`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Update a webhook URL`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/item/public_token/exchange`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Exchange a public token from Link for an access token`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/item/access_token/invalidate`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Rotate an access token without deleting the Item`}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`See also`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/sandbox/public_token/create`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Create a test Item (Sandbox only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/sandbox/item/reset_login`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Force an Item into an error state (Sandbox only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/sandbox/item/set_verification_status`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Set Auth verification status (Sandbox only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/sandbox/item/fire_webhook`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fire a test webhook (Sandbox only)`}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Webhooks`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#error"
            }}><inlineCode parentName="a">{`ERROR`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Item has entered an error state`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#login_repaired"
            }}><inlineCode parentName="a">{`LOGIN_REPAIRED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Item has healed from `}<inlineCode parentName="td">{`ITEM_LOGIN_REQUIRED`}</inlineCode>{` without update mode`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#new_accounts_available"
            }}><inlineCode parentName="a">{`NEW_ACCOUNTS_AVAILABLE`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`New account detected for an Item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#pending_disconnect"
            }}><inlineCode parentName="a">{`PENDING_DISCONNECT`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Item access is about to expire (US/CA) or end`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#pending_expiration"
            }}><inlineCode parentName="a">{`PENDING_EXPIRATION`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Item access is about to expire (UK/EU)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#user_permission_revoked"
            }}><inlineCode parentName="a">{`USER_PERMISSION_REVOKED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The user has revoked access to an Item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#user_account_revoked"
            }}><inlineCode parentName="a">{`USER_ACCOUNT_REVOKED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The user has revoked access to an account`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#webhook_update_acknowledged"
            }}><inlineCode parentName="a">{`WEBHOOK_UPDATE_ACKNOWLEDGED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Item webhook URL updated`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "token-exchange-flow"
    }}>{`Token exchange flow`}</h3>
    <p>{`Many API calls to Plaid product endpoints require an `}<inlineCode parentName="p">{`access_token`}</inlineCode>{`. An `}<inlineCode parentName="p">{`access_token`}</inlineCode>{` corresponds to an `}<em parentName="p">{`Item`}</em>{`, which is a login at a financial institution. To obtain an `}<inlineCode parentName="p">{`access_token`}</inlineCode>{`: `}</p>
    <ol>
      <li parentName="ol">{`Obtain a `}<inlineCode parentName="li">{`link_token`}</inlineCode>{` by calling `}<inlineCode parentName="li">{`/link/token/create`}</inlineCode>{`.`}</li>
      <li parentName="ol">{`Initialize Link by passing in the `}<inlineCode parentName="li">{`link_token`}</inlineCode>{`. When your user completes the
Link flow, Link will pass back a `}<inlineCode parentName="li">{`public_token`}</inlineCode>{` via the
`}<a parentName="li" {...{
          "href": "/docs/link/web/#onsuccess"
        }}><inlineCode parentName="a">{`onSuccess`}</inlineCode>{` callback`}</a>{`, or, if using `}<a parentName="li" {...{
          "href": "/docs/link/hosted-link"
        }}>{`Hosted Link`}</a>{`, via a webhook. For more information on
initializing and receiving data back from Link, see the
`}<a parentName="li" {...{
          "href": "/docs/link"
        }}>{`Link documentation`}</a>{`.`}</li>
      <li parentName="ol">{`Exchange the `}<inlineCode parentName="li">{`public_token`}</inlineCode>{` for an `}<inlineCode parentName="li">{`access_token`}</inlineCode>{` by calling
`}<inlineCode parentName="li">{`/item/public_token/exchange`}</inlineCode>{`.`}
        <br />
      </li>
    </ol>
    <p>{`The `}<inlineCode parentName="p">{`access_token`}</inlineCode>{` can then be used to call Plaid endpoints and obtain
information about an Item.`}</p>
    <p>{`In addition to the primary flow, several other token flows exist. The
`}<a parentName="p" {...{
        "href": "/docs/link/update-mode"
      }}>{`Link update mode`}</a>{` flow allows you to update an
`}<inlineCode parentName="p">{`access_token`}</inlineCode>{` that has stopped working. The Sandbox testing environment also
offers the `}<inlineCode parentName="p">{`/sandbox/public_token/create`}</inlineCode>{` endpoint, which allows you to create a
`}<inlineCode parentName="p">{`public_token`}</inlineCode>{` without using Link. The `}<a parentName="p" {...{
        "href": "/docs/link/hosted-link"
      }}>{`Hosted Link`}</a>{` and `}<a parentName="p" {...{
        "href": "/docs/link/multi-item-link/"
      }}>{`Multi-Item Link`}</a>{` flows provide the `}<inlineCode parentName="p">{`public_token`}</inlineCode>{` via the backend rather than using the frontend `}<inlineCode parentName="p">{`onSuccess`}</inlineCode>{` callback.`}</p>
    <h3 {...{
      "id": "endpoints"
    }}>{`Endpoints`}</h3>
    <h4 {...{
      "id": "itemget"
    }}>{`/item/get`}</h4>
    <Schema method='POST' route='/item/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/item/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/item/get \\
  -H 'Content-Type: application/json' \\
  -d '{
    "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
    "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
    "access_token": String
  }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: ItemGetRequest = {
  access_token: accessToken,
};
try {
  const response = await plaidClient.itemGet(request);
  const item = response.data.item;
  const status = response.data.status;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ItemGetRequest(access_token=accessToken)
response = client.item_get(request)
item = response['item']
status = response['status']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ItemGetRequest request = new ItemGetRequest()
  .accessToken(accessToken);
Response<ItemGetResponse> response = client().itemGet(request).execute();
ItemWithConsentFields item = response.body().getItem();
ItemStatusNullable status = response.body().getStatus();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::ItemGetRequest.new({ access_token: accessToken })
response = client.item_get(request)
item = response.item
status = response.status
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewItemGetRequest(accessToken)
resp, _, err := client.PlaidApi.ItemGet(ctx).ItemGetRequest(*request).Execute()

item := resp.GetItem()
status := resp.GetStatus()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.ItemGetRequest{AccessToken: accessToken}
resp, err := client.Item.Get(ctx, request)

item := resp.GetItem()
status := resp.GetStatus()
`}</code></pre>
      </MDXCodeBlock>
  
    </Schema>
    <Schema method='POST' route='/item/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "itemremove"
    }}>{`/item/remove`}</h4>
    <Schema method='POST' route='/item/remove' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/item/remove' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/item/remove \\
  -H 'Content-Type: application/json' \\
  -d '{
    "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
    "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
    "access_token": String
  }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: ItemRemoveRequest = {
  access_token: accessToken,
};
try {
  const response = await plaidClient.itemRemove(request);
  // The Item was removed, access_token is now invalid
} catch (error) {
  // handle error
}

// The Item was removed, access_token is now invalid
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ItemRemoveRequest(access_token=accessToken)
response = client.item_remove(request)
# The Item was removed and the access_token is now invalid
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ItemRemoveRequest request = new ItemRemoveRequest()
  .accessToken(accessToken);
Response<ItemRemoveResponse> response = client()
  .itemRemove(request)
  .execute();
// The Item was removed and the access_token is now invalid
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::ItemRemoveRequest.new({ access_token: accessToken })
response = client.item_remove(request)
# The Item was removed and the access_token is now invalid
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewItemRemoveRequest(accessToken)
_, _, err := client.PlaidApi.ItemRemove(ctx).ItemRemoveRequest(*request).Execute()
// The Item was removed and the access_token is now invalid
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.ItemRemoveRequest{AccessToken: accessToken}
_, err := client.Item.Remove(ctx, request)
// The Item was removed and the access_token is now invalid
`}</code></pre>
      </MDXCodeBlock>
  
    </Schema>
    <Schema method='POST' route='/item/remove' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "itemwebhookupdate"
    }}>{`/item/webhook/update`}</h4>
    <Schema method='POST' route='/item/webhook/update' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/item/webhook/update' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`// Update the webhook associated with an Item
const request: ItemWebhookUpdateRequest = {
  access_token: accessToken,
  webhook: 'https://example.com/updated/webhook',
};
try {
  const response = await plaidClient.itemWebhookUpdate(request);
  // A successful response indicates that the webhook has been
  // updated. An acknowledgement webhook will also be fired.
  const item = response.data.item;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/item/webhook/update \\
  -H 'Content-Type: application/json' \\
  -d '{
    "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
    "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
    "access_token": String,
    "webhook": "https://example.com/updated/hook"
  }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`  # update the webhook associated with an item
request = Plaid::ItemWebhookUpdateRequest.new(
  {
    access_token: accessToken,
    webhook: "https://example.com/updated/webhook"
  }
)
response = client.item_webhook_update(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`// Update the webhook associated with an Item
String webhookUrl = "https://example.com/updated/webhook";
ItemWebhookUpdateRequest request = new ItemWebhookUpdateRequest()
  .accessToken(accessToken)
  .webhook(webhookUrl);
Response<ItemWebhookUpdateResponse> webhookResponse = client()
  .itemWebhookUpdate(request)
  .execute();
// A successful response indicates that the webhook has been
// updated. An acknowledgement webhook will also be fired.
Item item = webhookResponse.body().getItem();
String updatedWebhook = item.getWebhook();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`# update the webhook associated with an item
request = ItemWebhookUpdateRequest(
    access_token=accessToken,
    webhook='https://example.com/updated/webhook'
)
response = client.item_webhook_update(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewItemWebhookUpdateRequest(accessToken)
request.SetWebhook("https://plaid.com/webhook-test")
resp, _, err := client.PlaidApi.ItemWebhookUpdate(ctx).ItemWebhookUpdateRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.ItemWebhookUpdateRequest{AccessToken: accessToken}
request.Webhook = plaid.String("https://plaid.com/webhook-test")
resp, err := client.Item.UpdateWebhook(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
  
    </Schema>
    <Schema method='POST' route='/item/webhook/update' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "itempublic_tokenexchange"
    }}>{`/item/public_token/exchange`}</h4>
    <Schema method='POST' route='/item/public_token/exchange' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/item/public_token/exchange' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: ItemPublicTokenExchangeRequest = {
  public_token: publicToken,
};
try {
  const response = await plaidClient.itemPublicTokenExchange(request);
  const accessToken = response.data.access_token;
  const itemId = response.data.item_id;
} catch (err) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/item/public_token/exchange \\
  -H 'Content-Type: application/json' \\
  -d '{
    "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
    "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
    "public_token": "public-sandbox-5c224a01-8314-4491-a06f-39e193d5cddc"
  }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::ItemPublicTokenExchangeRequest.new({ public_token: public_token })
response = client.item_public_token_exchange(request)
access_token = response.access_token
item_id = response.item_id
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ItemPublicTokenExchangeRequest request = new ItemPublicTokenExchangeRequest()
  .publicToken(publicToken);
Response<ItemPublicTokenExchangeResponse> response = client()
  .itemPublicTokenExchange(request)
  .execute();
String accessToken = response.body().getAccessToken();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ItemPublicTokenExchangeRequest(public_token=public_token)
response = client.item_public_token_exchange(request)
access_token = response['access_token']
item_id = response['item_id']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`exchangePublicTokenReq := plaid.NewItemPublicTokenExchangeRequest(sandboxPublicTokenResp.GetPublicToken())
exchangePublicTokenResp, _, err := client.PlaidApi.ItemPublicTokenExchange(ctx).ItemPublicTokenExchangeRequest(
  *exchangePublicTokenReq,
).Execute()
accessToken := exchangePublicTokenResp.GetAccessToken()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`exchangePublicTokenReq := &plaid.ItemPublicTokenExchangeRequest{PublicToken: sandboxPublicTokenResp.GetPublicToken()}
exchangePublicTokenResp, err := client.Item.ExchangePublicToken(ctx, exchangePublicTokenReq)
accessToken := exchangePublicTokenResp.GetAccessToken()
`}</code></pre>
      </MDXCodeBlock>
  
    </Schema>
    <Schema method='POST' route='/item/public_token/exchange' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "itemaccess_tokeninvalidate"
    }}>{`/item/access_token/invalidate`}</h4>
    <Schema method='POST' route='/item/access_token/invalidate' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/item/access_token/invalidate' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`// Generate a new access_token for an Item, invalidating the old one
const request: ItemAccessTokenInvalidateRequest = {
  access_token: accessToken,
};
try {
  const response = await plaidClient.itemAccessTokenInvalidate(request);
  // Store the new access_token in a persistent, secure datastore
  const accessToken = response.data.new_access_token;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/item/access_token/invalidate \\
  -H 'Content-Type: application/json' \\
  -d '{
    "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
    "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
    "access_token": String
  }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`# generate a new access_token for an item, invalidating the old one
request = Plaid::ItemAccessTokenInvalidateRequest.new({ access_token: access_token })
response = client.item_access_token_invalidate(request)
# store the new access_token in a persistent, secure datastore
new_access_token = response.new_access_token
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`// Generate a new access_token for an Item, invalidating the old one
ItemAccessTokenInvalidateRequest request = new ItemAccessTokenInvalidateRequest()
  .accessToken(accessToken);
Response<ItemAccessTokenInvalidateResponse> response = client()
  .itemAccessTokenInvalidate(request)
  .execute();

String newAccessToken;
if (response.isSuccessful()) {
  // Store the new access_token in a persistent, secure datastore
  newAccessToken = response.body().getNewAccessToken();
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`# generate a new access_token for an item, invalidating the old one
request = ItemAccessTokenInvalidateRequest(access_token=access_token)
response = client.item_access_token_invalidate(request)
# store the new access_token in a persistent, secure datastore
new_access_token = response['new_access_token']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`// Generate a new access_token for an Item, invalidating the old one
request := plaid.NewItemAccessTokenInvalidateRequest(accessToken)
response, _, err := client.PlaidApi.ItemAccessTokenInvalidate(ctx).ItemAccessTokenInvalidateRequest(
  *request,
).Execute()

// Store the new access_token in a persistent, secure datastore
newAccessToken := response.GetNewAccessToken()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`// Generate a new access_token for an Item, invalidating the old one
request := &plaid.ItemAccessTokenInvalidateRequest{AccessToken: accessToken}
response, err := client.Item.InvalidateAccessToken(ctx, request)

// Store the new access_token in a persistent, secure datastore
newAccessToken := response.GetNewAccessToken()
`}</code></pre>
      </MDXCodeBlock>
  
    </Schema>
    <Schema method='POST' route='/item/access_token/invalidate' type='response' mdxType="Schema" />
    <h3 {...{
      "id": "webhooks"
    }}>{`Webhooks`}</h3>
    <p>{`Webhooks are used to communicate changes to an Item, such as an updated webhook, or errors encountered with an Item. The error typically requires user action to resolve, such as when a user changes their password. All Item webhooks have a `}<inlineCode parentName="p">{`webhook_type`}</inlineCode>{` of `}<inlineCode parentName="p">{`ITEM`}</inlineCode>{`.`}</p>
    <h4 {...{
      "id": "error"
    }}><inlineCode parentName="h4">{`ERROR`}</inlineCode></h4>
    <Schema model='ItemErrorWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "login_repaired"
    }}><inlineCode parentName="h4">{`LOGIN_REPAIRED`}</inlineCode></h4>
    <Schema model='ItemLoginRepairedWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "new_accounts_available"
    }}><inlineCode parentName="h4">{`NEW_ACCOUNTS_AVAILABLE`}</inlineCode></h4>
    <Schema model='NewAccountsAvailableWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "pending_disconnect"
    }}><inlineCode parentName="h4">{`PENDING_DISCONNECT`}</inlineCode></h4>
    <Schema model='PendingDisconnectWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "pending_expiration"
    }}><inlineCode parentName="h4">{`PENDING_EXPIRATION`}</inlineCode></h4>
    <Schema model='PendingExpirationWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "user_permission_revoked"
    }}><inlineCode parentName="h4">{`USER_PERMISSION_REVOKED`}</inlineCode></h4>
    <Schema model='UserPermissionRevokedWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "user_account_revoked"
    }}><inlineCode parentName="h4">{`USER_ACCOUNT_REVOKED`}</inlineCode></h4>
    <Schema model='UserAccountRevokedWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "webhook_update_acknowledged"
    }}><inlineCode parentName="h4">{`WEBHOOK_UPDATE_ACKNOWLEDGED`}</inlineCode></h4>
    <Schema model='WebhookUpdateAcknowledgedWebhook' type='model' mdxType="Schema" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "token-exchange-flow",
        level: 3,
        title: "Token exchange flow",
      },
{
        id: "endpoints",
        level: 3,
        title: "Endpoints",
      },
{
        id: "itemget",
        level: 4,
        title: "/item/get",
      },
{
        id: "itemremove",
        level: 4,
        title: "/item/remove",
      },
{
        id: "itemwebhookupdate",
        level: 4,
        title: "/item/webhook/update",
      },
{
        id: "itempublic_tokenexchange",
        level: 4,
        title: "/item/public_token/exchange",
      },
{
        id: "itemaccess_tokeninvalidate",
        level: 4,
        title: "/item/access_token/invalidate",
      },
{
        id: "webhooks",
        level: 3,
        title: "Webhooks",
      },
{
        id: "error",
        level: 4,
        title: "ERROR",
      },
{
        id: "login_repaired",
        level: 4,
        title: "LOGIN_REPAIRED",
      },
{
        id: "new_accounts_available",
        level: 4,
        title: "NEW_ACCOUNTS_AVAILABLE",
      },
{
        id: "pending_disconnect",
        level: 4,
        title: "PENDING_DISCONNECT",
      },
{
        id: "pending_expiration",
        level: 4,
        title: "PENDING_EXPIRATION",
      },
{
        id: "user_permission_revoked",
        level: 4,
        title: "USER_PERMISSION_REVOKED",
      },
{
        id: "user_account_revoked",
        level: 4,
        title: "USER_ACCOUNT_REVOKED",
      },
{
        id: "webhook_update_acknowledged",
        level: 4,
        title: "WEBHOOK_UPDATE_ACKNOWLEDGED",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
